import { React, useState, useRef } from "react";
// import "./SocietyRegistration.css";
import "./PrivateLimitedCompany.css";
import ContactPopup from "./ContactPopup";


const SocietyRegistration = () => {
  const [openPopup, setOpenPopup] = useState(false);

  const contactRef = useRef(null);

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="page">

      {/* HERO */}
      <div className="hero">

        <h1>Society Registration Services</h1>

        <p className="subtitle">
          Register Your Society & Build a Recognized Organization
        </p>

        <p className="desc">
          Ideal for NGOs, Associations, Clubs & Charitable Groups. We assist you in registering a Society quickly and legally, ensuring full compliance so you can focus on your social, cultural, or charitable goals.
        </p>

        <div className="badges">
          <span>✔ Suitable for NGOs & Associations</span>
          <span>✔ Legal Recognition</span>
          <span>✔ Affordable & Transparent Pricing</span>
          <span>✔ End-to-End Support</span>
        </div>

        <div className="hero-action">
          <button className="hero-btn" onClick={scrollToContact}>
            Get Started Today
          </button>
        </div>

      </div>

      {/* WHAT IS SOCIETY */}
      <div className="section">
        <h2>What is a Society?</h2>
        <p>
          A Society is a non-profit organization formed by a group of individuals united for a common purpose such as education, charity, culture, science, or social welfare. It is governed by the Societies Registration Act, 1860.
        </p>
      </div>

      {/* OBJECTIVES */}
      <div className="section">
        <h2>Objectives of Society Registration</h2>
        <ul>
          <li>Promotion of education</li>
          <li>Charitable activities</li>
          <li>Cultural and social development</li>
          <li>Environmental protection</li>
          <li>Sports and arts promotion</li>
          <li>Community welfare initiatives</li>
        </ul>
      </div>

      {/* BENEFITS */}
      <div className="section">
        <h2>Benefits of Society Registration</h2>
        <ul>
          <li>Legal recognition of organization</li>
          <li>Separate legal identity</li>
          <li>Eligibility for grants and funding</li>
          <li>Tax benefits (12A & 80G optional)</li>
          <li>Democratic management structure</li>
          <li>Increased credibility</li>
        </ul>
      </div>

      {/* SERVICES */}
      <div className="section">
        <h2>Our Services Include</h2>
        <ul>
          <li>Name Selection & Approval Guidance</li>
          <li>Drafting of Memorandum of Association (MOA)</li>
          <li>Drafting of Rules & Regulations</li>
          <li>Documentation & Filing</li>
          <li>Registration Certificate</li>
          <li>PAN Application</li>
          <li>Assistance with 12A & 80G Registration (optional)</li>
        </ul>
      </div>

      {/* DOCUMENTS */}
      <div className="section">
        <h2>Documents Required</h2>

        <h3>For Members (Minimum 7):</h3>
        <ul>
          <li>PAN Card</li>
          <li>Aadhaar / Passport / Voter ID</li>
          <li>Passport-size Photograph</li>
          <li>Address Proof</li>
        </ul>

        <h3>For Registered Office:</h3>
        <ul>
          <li>Rent Agreement (if rented)</li>
          <li>NOC from Owner</li>
          <li>Utility Bill (Electricity/Water)</li>
        </ul>
      </div>

      {/* ELIGIBILITY */}
      <div className="section">
        <h2>Eligibility Criteria</h2>
        <ul>
          <li>Minimum 7 members required</li>
          <li>Members can be individuals, companies, or societies</li>
          <li>Common objective for non-profit purpose</li>
          <li>Registered office address required</li>
        </ul>
      </div>

      {/* PROCESS */}
      <div className="section">
        <h2>Registration Process</h2>
        <ul>
          <li>Consultation – Understand objectives</li>
          <li>Document Preparation – Draft MOA & Rules</li>
          <li>Submission – File application with Registrar</li>
          <li>Verification – Authority reviews documents</li>
          <li>Approval – Receive Society Registration Certificate</li>
        </ul>
      </div>

      {/* PRICING */}
      <div className="section">
        <h2>Pricing Plans</h2>

        <div className="grid">

          <div className="card blue">
            <h3>Basic Plan</h3>
            <ul>
              <li>MOA Drafting</li>
              <li>Rules & Regulations</li>
            </ul>
          </div>

          <div className="card purple">
            <h3>Standard Plan</h3>
            <ul>
              <li>Everything in Basic</li>
              <li>Filing & Registration</li>
              <li>PAN Application</li>
            </ul>
          </div>

          <div className="card orange">
            <h3>Premium Plan</h3>
            <ul>
              <li>Everything in Standard</li>
              <li>12A & 80G Assistance</li>
              <li>Compliance Support</li>
            </ul>
          </div>

        </div>
      </div>

      {/* WHY US */}
      <div className="section">
        <h2>Why Choose Us?</h2>
        <ul>
          <li>NGO & Society Registration Experts</li>
          <li>Fast Processing</li>
          <li>Transparent Pricing</li>
          <li>Dedicated Support</li>
          <li>End-to-End Service</li>
        </ul>
      </div>

      {/* FAQ */}
      <div className="section">
        <h2>FAQs</h2>

        <p><b>Minimum members required?</b> 7 members required.</p>
        <p><b>Can society earn profit?</b> Yes, but must be used for objectives.</p>
        <p><b>Society vs Section 8?</b> Section 8 has higher credibility.</p>
        <p><b>Registration time?</b> 10–15 working days.</p>
      </div>

      {/* CTA */}
      <div className="cta"
        ref={contactRef}>
        <h2>Start Your Society Today</h2>
        <p>Register your organization and make a meaningful impact.</p>

        <div className="cta-buttons">
          <button onClick={() => setOpenPopup(true)}
          >Contact Us Now</button>

          <ContactPopup
            isOpen={openPopup}
            onClose={() => setOpenPopup(false)}
          />

          <button className="outline" onClick={() => window.location.href = "tel:9218103915"}
          >Free Consultation</button>
        </div>
      </div>

    </div>
  );
};

export default SocietyRegistration;